const FAVORITE_TOGGLED_EVENT = "favorite-toggled";

export function emitFavoriteToggled(detail) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(FAVORITE_TOGGLED_EVENT, {
      detail,
    })
  );
}

export function subscribeFavoriteToggled(callback) {
  if (typeof window === "undefined") return () => {};

  const handler = (event) => {
    callback(event?.detail || {});
  };

  window.addEventListener(FAVORITE_TOGGLED_EVENT, handler);
  return () => {
    window.removeEventListener(FAVORITE_TOGGLED_EVENT, handler);
  };
}
